import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { ScrollingService } from 'src/app/services/scrolling.service';

import { CompatibilityService } from '../../../services/compatibility.service';
import { TranslateModule } from '@ngx-translate/core';
import { OpticalSensorTutorialComponent } from './optical-sensor-tutorial/optical-sensor-tutorial.component';
import { BrandSelectionComponent } from './brand-selection/brand-selection.component';
import { NgClass, NgIf, AsyncPipe } from '@angular/common';
import { LazyImageDirective } from '../../../../../../../directive/lazyImage.directive';
import { CompatibilityCardComponent } from '../../shared/compatibility-card/compatibility-card.component';

@Component({
    selector: 'app-brand-list',
    templateUrl: './brand-list.component.html',
    styleUrls: ['./brand-list.component.scss'],
    standalone: true,
    imports: [
        CompatibilityCardComponent,
        LazyImageDirective,
        NgClass,
        NgIf,
        BrandSelectionComponent,
        OpticalSensorTutorialComponent,
        AsyncPipe,
        TranslateModule,
    ],
})
export class BrandListComponent {
  isOpticalSelected$: Observable<boolean> =
    this.compatibilityService.isOpticalSelected$;

  constructor(
    private compatibilityService: CompatibilityService,
    private scrollingService: ScrollingService
  ) {}

  onSelectOpticalIfTrue(choice: boolean): void {
    this.compatibilityService.selectOpticalIfTrue(choice);

    const elementId = choice ? 'opticalSensorTutorial' : 'brandSelection';
    this.scrollingService.detectChangesAndScrollSmoothlyTo(elementId);
  }
}
